/* copies each brand heading's text into data-text, for the inline layer in brand-font.css */
(function () {
  var sel = '.nav-wordmark, .section-title, .soon__mark, .pdp-title';
  function run() {
    document.querySelectorAll(sel).forEach(function (el) { el.setAttribute('data-text', el.textContent.trim()); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();